const conditionInfo = {
    customer: '',
    margin: '',
    option: '',
    taxPlayer: '',
    clear: '',
    agreew8: '',
    agreeConfirm: '',
    agreeEstatement: '',
    agreeProxy: '',
    agreePros: '',
    agreeEtax: '',
    disclosure: '',
    privacy: '',
    finder: '',
    limit: ''
};

const SET_CONDITION_INFO = 'SET_CONDITION_INFO';
const SET_FINDER = 'SET_FINDER';
const SET_LIMIT = 'SET_LIMIT';

export const setConditionInfo = (conditionInfo) => ({
    type: SET_CONDITION_INFO,
    payload: conditionInfo,
});

export const setFinder = (finder) => ({
    type: SET_FINDER,
    payload: finder,
});

export const setLimit = (limit) => ({
    type: SET_LIMIT,
    payload: limit,
});

const condition_store = (state = conditionInfo, action) => {
    switch (action.type) {
        case SET_CONDITION_INFO:
            return {
                ...state,
                ...action.payload,
            };
        case SET_FINDER:
            return {
                ...state,
                finder: action.payload,
            };
        case SET_LIMIT:
            return {
                ...state,
                limit: action.payload,
            };
        default:
            return state;
    }
};

export default condition_store;
